import type { ChainNetwork } from '@ducat-unit/core';

export { getWalletConnector, loadWalletConnector } from './wallet-connector-loader';

export function parse_error(err: unknown): string {
  if (err instanceof Error) {
    return err.message;
  } else if (typeof err === 'string') {
    return err;
  } else {
    return String(err);
  }
}

export async function wait(ms: number, signal?: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(new DOMException('Wait cancelled', 'AbortError'));
      return;
    }

    const timeoutId = setTimeout(resolve, ms);

    signal?.addEventListener(
      'abort',
      () => {
        clearTimeout(timeoutId);
        reject(new DOMException('Wait cancelled', 'AbortError'));
      },
      { once: true },
    );
  });
}

export function getMinNotZero(a: number, b: number, c: number) {
  if (a && a < b && a < c) {
    return a;
  }

  return Math.min(b, c);
}

export function isMainNetwork(network: ChainNetwork) {
  return ['main', 'alpha-mainnet'].includes(network);
}
